/* eslint-disable import/prefer-default-export */
import { request } from '../utils/request';

export const getVideoIframeApi = data =>
  request.get('/admin/hubs/video-iframe', { params: data });
